import cmsSettings from '../cmsSettings'
import { richTextFields } from '../_shared'
import { basicProductFields } from '../_shared'
import productCategory from '../productCategory'
import link from '../link'
import imageAsset from '../imageAsset'

export const fields = `
  _type,
  _id,
  ${cmsSettings()},
  title,
  ${imageAsset.fragment('backgroundImageRight')},
  ${imageAsset.fragment('backgroundImageLeft')},
  shortDescription[]{
    ${richTextFields}
  },
  longDescription[]{
    ${richTextFields}
  },
  categories[]{
    category->{${productCategory.fields}},
    productExample->{${basicProductFields}}
  },
  "detailsTitle": coalesce(detailsTitle, "Details"),
  details[]{
    ${link.fields}
  }
`

export const fragment = (name = 'aboutHero') => `${name}{ ${fields} }`

const exported = {
  fields,
  fragment,
}

export default exported
